import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
export var RecognitionMode;

(function (RecognitionMode) {
  RecognitionMode[RecognitionMode["Interactive"] = 0] = "Interactive";
  RecognitionMode[RecognitionMode["Conversation"] = 1] = "Conversation";
  RecognitionMode[RecognitionMode["Dictation"] = 2] = "Dictation";
})(RecognitionMode || (RecognitionMode = {}));

export var SpeechResultFormat;

(function (SpeechResultFormat) {
  SpeechResultFormat[SpeechResultFormat["Simple"] = 0] = "Simple";
  SpeechResultFormat[SpeechResultFormat["Detailed"] = 1] = "Detailed";
})(SpeechResultFormat || (SpeechResultFormat = {}));

export var RecognizerConfig = /*#__PURE__*/function () {
  function RecognizerConfig(speechServiceConfig, parameters) {
    _classCallCheck(this, RecognizerConfig);

    this.privRecognitionMode = RecognitionMode.Interactive;
    this.privSpeechServiceConfig = speechServiceConfig ? speechServiceConfig : new SpeechServiceConfig(new Context(null));
    this.privParameters = parameters;
  }

  _createClass(RecognizerConfig, [{
    key: "parameters",
    get: function get() {
      return this.privParameters;
    }
  }, {
    key: "recognitionMode",
    get: function get() {
      return this.privRecognitionMode;
    },
    set: function set(value) {
      this.privRecognitionMode = value;
      this.privRecognitionActivityTimeout = value === RecognitionMode.Interactive ? 8000 : 25000;
      this.privSpeechServiceConfig.Recognition = RecognitionMode[value];
    }
  }, {
    key: "SpeechServiceConfig",
    get: function get() {
      return this.privSpeechServiceConfig;
    }
  }, {
    key: "recognitionActivityTimeout",
    get: function get() {
      return this.privRecognitionActivityTimeout;
    }
  }, {
    key: "isContinuousRecognition",
    get: function get() {
      return this.privRecognitionMode !== RecognitionMode.Interactive;
    }
  }]);

  return RecognizerConfig;
}(); // The config is serialized and sent as the Speech.Config
// tslint:disable-next-line:max-classes-per-file

export var SpeechServiceConfig = /*#__PURE__*/function () {
  function SpeechServiceConfig(context) {
    var _this = this;

    _classCallCheck(this, SpeechServiceConfig);

    this.serialize = function () {
      return JSON.stringify(_this, function (key, value) {
        if (value && typeof value === "object") {
          var replacement = {};

          for (var k in value) {
            if (Object.hasOwnProperty.call(value, k)) {
              replacement[k && k.charAt(0).toLowerCase() + k.substring(1)] = value[k];
            }
          }

          return replacement;
        }

        return value;
      });
    };

    this.context = context;
  }

  _createClass(SpeechServiceConfig, [{
    key: "Context",
    get: function get() {
      return this.context;
    }
  }, {
    key: "Recognition",
    get: function get() {
      return this.recognition;
    },
    set: function set(value) {
      this.recognition = value.toLowerCase();
    }
  }]);

  return SpeechServiceConfig;
}(); // tslint:disable-next-line:max-classes-per-file

export var Context = function Context(os) {
  _classCallCheck(this, Context);

  this.system = new System();
  this.os = os;
}; // tslint:disable-next-line:max-classes-per-file

export var System = function System() {
  _classCallCheck(this, System);

  // Note: below will be patched for official builds.
  var SPEECHSDK_CLIENTSDK_VERSION = "1.8.1";
  this.name = "SpeechSDK";
  this.version = SPEECHSDK_CLIENTSDK_VERSION;
  this.build = "JavaScript";
  this.lang = "JavaScript";
}; // tslint:disable-next-line:max-classes-per-file

export var OS = function OS(platform, name, version) {
  _classCallCheck(this, OS);

  this.platform = platform;
  this.name = name;
  this.version = version;
}; // tslint:disable-next-line:max-classes-per-file

export var Device = function Device(manufacturer, model, version) {
  _classCallCheck(this, Device);

  this.manufacturer = manufacturer;
  this.model = model;
  this.version = version;
};
export var connectivity;

(function (connectivity) {
  connectivity["Bluetooth"] = "Bluetooth";
  connectivity["Wired"] = "Wired";
  connectivity["WiFi"] = "WiFi";
  connectivity["Cellular"] = "Cellular";
  connectivity["InBuilt"] = "InBuilt";
  connectivity["Unknown"] = "Unknown";
})(connectivity || (connectivity = {}));

export var type;

(function (type) {
  type["Phone"] = "Phone";
  type["Speaker"] = "Speaker";
  type["Car"] = "Car";
  type["Headset"] = "Headset";
  type["Thermostat"] = "Thermostat";
  type["Microphones"] = "Microphones";
  type["Deskphone"] = "Deskphone";
  type["RemoteControl"] = "RemoteControl";
  type["Unknown"] = "Unknown";
  type["File"] = "File";
  type["Stream"] = "Stream";
})(type || (type = {}));